import { SVGProps } from 'react';

const Brain = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 18V5m0 13a3.998 3.998 0 0 0 5.824 3.556 4 4 0 0 0 2.143-4.073M12 18a4 4 0 1 1-7.967-.517M12 5a3 3 0 1 1 5.598 1.5M12 5a3.001 3.001 0 1 0-5.598 1.5M15 13a4.17 4.17 0 0 1-3-4 4.17 4.17 0 0 1-3 4m8.997-7.875a4 4 0 0 1 2.526 5.77M18 18a4 4 0 0 0 2-7.464M6 18a4 4 0 0 1-2-7.464m2.003-5.411a4 4 0 0 0-2.526 5.77"
    />
  </svg>
);
export default Brain;
